// @ts-nocheck
import styled from 'styled-components'
import { Alert } from 'antd'
import variables from 'Styled/variables'

// @ts-ignore
export const AlertStyled = styled(Alert)<{ noGap: boolean }>`
  &.ant-alert-with-description.ant-alert-no-icon {
    padding: ${({ noGap }) => (noGap ? `0` : `16px 16px 16px 16px`)};
  }
  && {
    margin-bottom: ${({ noGap }) => (noGap ? `0` : `24px`)};
    background-color: ${variables.colorWhite};
    border: 0;
  }
  .ant-alert-message {
    display: none;
  }
  .ant-alert {
    background-color: red;
  }
`

export const AlertContent = styled.div<{ rowDirection?: boolean }>`
  width: 100%;
  display: flex;
  flex-wrap: ${({ rowDirection }) => (rowDirection ? 'nowrap' : 'wrap')};
  flex-direction: ${({ rowDirection }) => (rowDirection ? 'row' : 'column')};
  justify-content: ${({ rowDirection }) =>
    rowDirection ? 'flex-start' : 'space-between !important'};
  @media screen and (min-width: 1330px) {
    flex-direction: row;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
`
export const AlertWrapper = styled.div`
  display: flex;
`

export const AlertIcon = styled.div`
  padding-top: 2.4px;
  display: flex;
  align-items: flex-start;
  img {
    width: 16px;
  }
`

export const AlertContentChildren = styled.div`
  font-size: 14px;
  line-height: 21px;
  color: #646877;
  margin-left: 7px;
`
